import React from 'react';
import PropTypes from 'prop-types';
import { formatClassName as _formatClassName } from '../../utils/formatClassName.js';

/** renders a div that styles contained headers/sections */
var Wrapper = function Wrapper(props) {
  var children = props.children,
    className = props.className,
    style = props.style;
  return /*#__PURE__*/React.createElement("div", {
    className: _formatClassName(['wrapper', className]),
    style: style
  }, children);
};
Wrapper.displayName = "Wrapper";
Wrapper.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  style: PropTypes.object
};
export { Wrapper };